import { type Mesh } from '@/gfx/mesh';

export const createGroundTileMesh = (size: number): Mesh => {
  const h = size * 0.5;
  // Quad facing +Y; CCW from above so normals point up under our cull rules.
  // prettier-ignore
  const positions = new Float32Array([
    -h, 0, +h,
    +h, 0, +h,
    +h, 0, -h,
    -h, 0, -h,
  ]);
  // prettier-ignore
  const normals = new Float32Array([
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
  ]);
  // prettier-ignore
  const uvs = new Float32Array([
    0, 1,
    1, 1,
    1, 0,
    0, 0,
  ]);
  const indices = new Uint16Array([0, 1, 2, 0, 2, 3]);
  return { positions, normals, uvs, indices };
};
